/**
 * @author sacotools
 */
import React from 'react';
import classNames from 'classnames';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Row, Col, Affix } from 'antd';

import MyAccountMenu from './MyAccountMenu';
import Profile from './profile/Profile';
import FAQ from './faq/FAQ';
import MyMoney from './my-money/MyMoney';
import Messages from './messages/Messages';
import Users from './admin/users/Users';
import Payouts from './admin/payouts/Payouts';
import Payments from './admin/payments/Payments';
import Marketing from './marketing/Marketing';
import Merch from './merch/Merch';

import './MyAccount.scss';

export default function MyAccount() {
  return (
    <Row
      className={classNames('MyAccount', { inRoot: true })}
      justify="center"
      align="middle"
    >
      <Col xs={22} sm={22} md={22} lg={22} xl={23} xxl={23}>
        <Row>
          <Col xs={24} sm={24} md={6} lg={5} xl={4} xxl={4}>
            <MyAccountMenu />
          </Col>
          <Col
            className="MyAccount__content"
            xs={24}
            sm={24}
            md={{ span: 17, offset: 1 }}
            lg={{ span: 18, offset: 1 }}
            xl={{ span: 19, offset: 1 }}
            xxl={{ span: 19, offset: 1 }}
          >
            <Routes>
              <Route
                path="/"
                element={<Navigate to="/my-account/edit-profile" replace />}
              />
              <Route path="/messages" element={<Messages />} />
              <Route path="/edit-profile" element={<Profile />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/my-money" element={<MyMoney />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/payouts" element={<Payouts />} />
              <Route path="/admin/payments" element={<Payments />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/merch" element={<Merch />} />
            </Routes>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
